// Category Configuration - labels, icons and features per category
// Uses Lucide React icons for consistency with existing design

export const CATEGORY_CONFIG = {
    boat: {
        id: 'boat',
        label: 'Botes',
        labelEn: 'Boats',
        icon: 'Sailboat',
        capacityLabel: 'Capacidad',
        capacityLabelEn: 'Capacity',
        sizeLabel: 'Eslora',
        sizeLabelEn: 'Length',
        sizeUnit: 'ft',
        searchPlaceholder: 'navegaapp.searchBoatsPlaceholder',
        showBoatType: true, // Tipo de bote (carType)
        showMake: true,
        showModel: true,
        showYear: true,
        showTransmission: true,
        showOdometer: true,
        showBedrooms: false,
        showBeds: false,
        showBathrooms: false,
        showCapacity: true, // Capacidad de personas
        allowHourlyBooking: true,
        defaultBookingMode: 'both'
    },
    posada: {
        id: 'posada',
        label: 'Posadas',
        labelEn: 'Inns',
        icon: 'Hotel',
        capacityLabel: 'Huespedes',
        capacityLabelEn: 'Guests',
        sizeLabel: 'Habitaciones',
        sizeLabelEn: 'Rooms',
        sizeUnit: 'hab',
        searchPlaceholder: 'navegaapp.searchPosadasPlaceholder',
        showBoatType: false, // No mostrar tipo de bote
        showMake: false,
        showModel: false,
        showYear: false,
        showTransmission: false,
        showOdometer: false,
        showBedrooms: true,
        showBeds: true,
        showBathrooms: true,
        showCapacity: true, // Capacidad de huespedes
        allowHourlyBooking: false,
        defaultBookingMode: 'daily'
    },
    experience: {
        id: 'experience',
        label: 'Experiencias',
        labelEn: 'Experiences',
        icon: 'Compass',
        capacityLabel: 'Participantes',
        capacityLabelEn: 'Participants',
        sizeLabel: 'Duracion',
        sizeLabelEn: 'Duration',
        sizeUnit: 'hrs',
        searchPlaceholder: 'navegaapp.searchExperiencesPlaceholder',
        showBoatType: false, // No mostrar tipo de bote
        showMake: false,
        showModel: false,
        showYear: false,
        showTransmission: false,
        showOdometer: false,
        showBedrooms: false,
        showBeds: false,
        showBathrooms: false,
        showCapacity: true, // Solo capacidad de participantes
        allowHourlyBooking: false,
        defaultBookingMode: 'daily'
    }
};

export const CATEGORY_LIST = Object.values(CATEGORY_CONFIG);

export const getCategoryConfig = (categoryType) =>
    CATEGORY_CONFIG[categoryType] || CATEGORY_CONFIG.boat;

export const isValidCategory = (category) =>
    ['boat', 'posada', 'experience'].includes(category);
